import { useEffect } from "react";

const LUMA_CHECKOUT_SCRIPT_ID = "luma-checkout";
const LUMA_CHECKOUT_SCRIPT_SRC = "https://embed.lu.ma/checkout-button.js";

export const useLumaCheckoutScript = () => {
  useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }

    if (document.getElementById(LUMA_CHECKOUT_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");
    script.id = LUMA_CHECKOUT_SCRIPT_ID;
    script.src = LUMA_CHECKOUT_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);
};

export const getLumaEventId = (lumaUrl: string) => {
  try {
    const url = new URL(lumaUrl);
    const pathParts = url.pathname.split("/").filter(Boolean);
    return pathParts.find((part) => part.startsWith("evt-")) ?? "";
  } catch {
    return "";
  }
};
